import React, { useState } from 'react';
import './InteractiveQuiz.css';

function InteractiveQuiz() {
  const questions = [
    {
      id: 1,
      question: 'Why can domestic cats NOT survive on a vegetarian or vegan diet?',
      options: [
        { label: 'They are obligate carnivores needing pre-formed taurine, arginine, and arachidonic acid', correct: true },
        { label: 'They dislike the taste of plant matter', correct: false },
        { label: 'Their stomach volume is too large for plant cellulose', correct: false }
      ],
      explanation: 'Cats lack specific metabolic synthesis pathways for taurine and arginine, which are exclusively available in animal tissues.'
    },
    {
      id: 2,
      question: 'When a cat rolls over and exposes their belly, what does it most likely mean?',
      options: [
        { label: 'They are requesting vigorous belly rubs', correct: false },
        { label: 'They feel safe and relaxed in your presence, but touching may trigger defense', correct: true },
        { label: 'They are preparing to jump onto a high shelf', correct: false }
      ],
      explanation: 'Exposing the vulnerable belly is a declaration of trust and comfort, but most cats will reflexively defend their organs if scratched there.'
    },
    {
      id: 3,
      question: 'What is the function of the cat\'s Jacobson\'s (vomeronasal) organ?',
      options: [
        { label: 'To cool body temperature through thermal evaporation', correct: false },
        { label: 'To analyze complex pheromones and chemical signals via the Flehmen response', correct: true },
        { label: 'To produce ultrasonic purring vibrations', correct: false }
      ],
      explanation: 'Located on the hard palate, it processes sociochemical pheromones left by other felines and their environment.'
    }
  ];

  const [userAnswers, setUserAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleSelect = (qId, optionIdx) => {
    setUserAnswers({
      ...userAnswers,
      [qId]: optionIdx
    });
  };

  const calculateScore = () => {
    let score = 0;
    questions.forEach((q) => {
      if (userAnswers[q.id] !== undefined && q.options[userAnswers[q.id]].correct) {
        score += 1;
      }
    });
    return score;
  };

  return (
    <section className="quiz-panel">
      <div className="section-header">
        <h2>Test Your Feline Ethology Knowledge</h2>
        <p>Verify how well you understand the biology and psychological language of cats.</p>
      </div>

      <div className="quiz-cards-wrapper">
        {questions.map((q) => (
          <div key={q.id} className="quiz-card">
            <p className="quiz-question">{q.id}. {q.question}</p>
            <div className="quiz-options">
              {q.options.map((opt, oIdx) => {
                const isSelected = userAnswers[q.id] === oIdx;
                let btnClass = 'quiz-opt-btn';
                if (isSelected) btnClass += ' selected';
                if (submitted) {
                  if (opt.correct) btnClass += ' is-correct';
                  else if (isSelected && !opt.correct) btnClass += ' is-wrong';
                }
                return (
                  <button
                    key={oIdx}
                    className={btnClass}
                    onClick={() => !submitted && handleSelect(q.id, oIdx)}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
            {submitted && (
              <div className="quiz-explanation">
                💡 {q.explanation}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="quiz-actions">
        {!submitted ? (
          <button
            className="quiz-submit-btn"
            disabled={Object.keys(userAnswers).length < questions.length}
            onClick={() => setSubmitted(true)}
          >
            Submit Quiz Answers
          </button>
        ) : (
          <div className="quiz-result-banner">
            <p>Score: {calculateScore()} / {questions.length}</p>
            <button
              className="quiz-retry-btn"
              onClick={() => {
                setSubmitted(false);
                setUserAnswers({});
              }}
            >
              Retake Quiz
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default InteractiveQuiz;